import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DriverService {
  addEditDriverSaveButtonClickSubject = new BehaviorSubject(0);
  supplierVehicleFormType = new BehaviorSubject('add');
  initAddDriverPopupForm = new BehaviorSubject(false);

  constructor(private http: HttpClient) {}

  createDriver(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/driver/create`, payload);
  }

  updateDriver(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/driver/update`, payload);
  }

  getDriverOptions(payload: any): Observable<any> {
    const options: any = { timeZoneName: 'long' };
    const formatter = new Intl.DateTimeFormat([], options);
    payload.timezone = formatter.resolvedOptions().timeZone;
    return this.http.post(`${SETTINGS.BASE_API}/driver/options`, payload);
  }
  getDriverOptionsWithUpcoming(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/driver/upcoming-options`,
      payload,
    );
  }

  getSupplierVehiclesByDriver(id: any): Observable<any> {
    return this.http.get(
      `${SETTINGS.BASE_API}/driver/get-all-supplier-vehicles/${id}`,
    );
  }

  getPagedDrivers(payload: any): Promise<any> {
    const options: any = { timeZoneName: 'long' };
    const formatter = new Intl.DateTimeFormat([], options);
    payload.filters.timezone = formatter.resolvedOptions().timeZone;
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/driver/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getDriverBookings(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/driver/get-bookings`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getPagedDriversBySupplier(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/driver/get-by-supplier`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  softDeleteDriver(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/driver/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getOneDriverByIdWithDetails(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/driver/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  getOneDriverById(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/driver/get/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }
}
